import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)


export const constantRoutes = [
  {
    path: '/',
    name:'index',
    component: () => import('@/views/index')
  },
  {
    path:'/map',
    name:'map',
    component: () => import('@/views/map/map')
  },
  {
    path:'/personal',
    name:'personal',
    component: () => import('@/views/personal/personal')
  },
  // {
  //   path:'/useradmin',
  //   name:'useradmin',
  //   component: () => import('@/views/usercenter/useradmin')
  // },
  {
    path:'/createIndex',
    name:'createIndex',
    component: () => import('@/views/components/createIndex')
  },
  {
    path:'/moreMapLists',
    name:'moreMapLists',
    component: () => import('@/views/more/moreMapLists')
  },
  {
    path:'/agricIndex',
    name:'agricIndex',
    component: () => import('@/views/navMoudles/agricIndex')
  },
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

router.beforeEach((to, from, next) => {
  console.log(to)
  if (!localStorage.getItem('portalToken') && from.path == '/') {
    next()
  }else{
      next()
  }
})


//解决报错 Uncaught (in promise) NavigationDuplicated 
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
export default router
